import { BaseApiService } from '@shared/services/BaseApiService';

export class BaseResourceApiService extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  getItem(id) {
    if (id !== null) {
      return this.http.get(`/${id}`);
    }
  }

  getList(params) {
    return this.http.get('', { params: params });
  }

  createItem(params) {
    return this.http.post('', params);
  }

  editItem(id, params) {
    return this.http.put(`/${id}`, params);
  }

  removeItem(id) {
    return this.http.delete(`/${id}`);
  }

  removeItemModal({ id }) {
    return this.removeItem(id);
  }
}
